import React, { FC } from "react";
import { graphql } from "gatsby";
import Layout from "../components/App/Layout";
import SEO from "../components/App/SEO";
import { ArticleEdge, BaseQueryData, HeadProps } from "../utils/core";
import DetailsContents from "../components/Legal/DetailsContents";

export const Head: FC<HeadProps> = ({ data }) => {
  const article = data.markdownRemark;
  return <SEO title={article?.frontmatter?.title} description={article?.frontmatter?.description} />;
};

const LegalDocument: FC<{ data: BaseQueryData<ArticleEdge> }> = ({ data }) => {
  const { markdownRemark } = data;

  return <Layout>
    <DetailsContents data={markdownRemark} />
  </Layout>
};

export default LegalDocument;

export const query = graphql`
query PrivacyQuery($id: String, $language: String) {
  markdownRemark(id: { eq: $id }) {
    frontmatter {
      authorid
      category
      date
      slug
      title
      description
    }
        html
        id
      }
      locales:  allLocale(filter: {language: {eq: $language}, ns: {in: ["components","pages"]}}) {
        edges {
          node {
            ns
            language
            data
          }
        }
      }
    }
`;

